export const theLightTheme = {
    type: 'light',
    primary: '#000',
    quaternary: '#27697a',
    quaternaryLight: '#F7F9F9',
    secondary: '#ffffff',
    tertiary: '#000000',
    buttonColor: '#0F1419',
    footerColor: '#F8F8FF',
}

export const theDarkTheme = {
    type: 'dark',
    primary: '#F0F1EC',
    secondary: '#272D3D',
    secondary2: '#000000',
    quaternary: '#0b2434',
    quaternaryLight: '#8b98a5',
    tertiary: '#EFF3F4',
    buttonColor: '#8B98A5',
    footerColor: '#F8F8FF',
}